"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestSlotDto = instanceOfDigestSlotDto;
exports.DigestSlotDtoFromJSON = DigestSlotDtoFromJSON;
exports.DigestSlotDtoFromJSONTyped = DigestSlotDtoFromJSONTyped;
exports.DigestSlotDtoToJSON = DigestSlotDtoToJSON;
exports.DigestSlotDtoToJSONTyped = DigestSlotDtoToJSONTyped;
/**
 * Check if a given object implements the DigestSlotDto interface.
 */
function instanceOfDigestSlotDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('time' in value) || value['time'] === undefined)
        return false;
    if (!('displayTime' in value) || value['displayTime'] === undefined)
        return false;
    return true;
}
function DigestSlotDtoFromJSON(json) {
    return DigestSlotDtoFromJSONTyped(json, false);
}
function DigestSlotDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'time': json['time'],
        'displayTime': json['displayTime'],
    };
}
function DigestSlotDtoToJSON(json) {
    return DigestSlotDtoToJSONTyped(json, false);
}
function DigestSlotDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'time': value['time'],
        'displayTime': value['displayTime'],
    };
}
